<template>
	<aside class="overlay updating">
		<i class="fas fa-spinner fa-spin"></i>
	</aside>
</template>

<script>
export default {
	name: 'SpinnerNew',
	props: ['text', 'hideText']
};
</script>

<style scoped>
	.overlay {
		width: 1.5em;
		height: 1.5em;
		line-height: 1.5em;
	}
	.no-shadow.overlay {
		box-shadow: none;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/SpinnerNew.vue